import { useState } from 'react'

import { Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import type { EventFeedConfig, EventPost } from '@/features/social-feed/model/types'
import { FeedCommentsSheet } from '@/features/social-feed/ui/FeedCommentsSheet'
import { PostCardPreview } from '@/features/social-feed/ui/PostCardPreview'
import { useEventSlug } from '@/shared/hooks/useEventSlug'
import { useNavigation } from '@/shared/hooks/useNavigation'

import 'swiper/css'
import 'swiper/css/pagination'

interface SocialFeedCarouselBlockProps {
  posts: EventPost[]
  feedConfig?: EventFeedConfig
}

/**
 * Carrossel do modo hub — substitui a pilha vertical de `PostCard` no corpo
 * de `SocialFeedBlock`. Um post por slide (`slidesPerView={1}`) com
 * paginação por dots, seguindo o padrão já estabelecido em
 * `shared/ui/StoriesViewer.jsx` (não o de `PartnersTopLikesCarousel.tsx`, que
 * é free-scroll sem dots) — `swiper@^11.1.14` já é dependência do projeto.
 */
export const SocialFeedCarouselBlock = ({ posts, feedConfig }: SocialFeedCarouselBlockProps) => {
  const eventSlug = useEventSlug()
  const { navigateTo } = useNavigation()
  const [openCommentsPostId, setOpenCommentsPostId] = useState<number | null>(null)

  return (
    <>
      <Swiper modules={[Pagination]} pagination={{ clickable: true }} slidesPerView={1}>
        {posts.map(post => (
          <SwiperSlide key={post.id}>
            <PostCardPreview
              post={post}
              allowedEmojis={feedConfig?.allowed_emojis ?? []}
              onOpenComments={setOpenCommentsPostId}
              onFocusPost={(id: number) => navigateTo(`/feed?post=${id}`)}
            />
          </SwiperSlide>
        ))}
      </Swiper>

      <FeedCommentsSheet
        eventSlug={eventSlug}
        postId={openCommentsPostId}
        onClose={() => setOpenCommentsPostId(null)}
      />
    </>
  )
}
